module.exports = "<div class=\"{{klass}}__audit  dialog-content\">\r\n    <p *ngFor=\"let auditTrail of auditTrailLog\">- {{auditTrail.createdDate|amFromUtc|amLocal|amDateFormat:appConstants.dateConfig.dateTime}} {{auditTrail.log}}</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/full-audit-trail/full-audit-trail.component.html
// module id = ../../../../../src/app/pages/consultation-history/full-audit-trail/full-audit-trail.component.html
// module chunks = main